<div class="tabs-container">
    <tabs (tabClicked)="onTabClicked($event)">
        <tab title="Legal">
            <ag-grid-angular class="data-grid " [rowData]="legalReviewFlows" [gridOptions]="legalGridOptions"  [attr.aria-label]="widgetTitle + ' - Legal'"></ag-grid-angular>
        </tab>
        <tab title="First">
            <ag-grid-angular class="data-grid " [rowData]="firstReviewFlows" [gridOptions]="firstReviewGridOptions"  [attr.aria-label]="widgetTitle + ' - First'"></ag-grid-angular>
        </tab>
        <tab title="Final">
            <ag-grid-angular class="data-grid " [rowData]="finalReviewFlows" [gridOptions]="finalReviewGridOptions"  [attr.aria-label]="widgetTitle + ' - Final'"></ag-grid-angular>
        </tab>
        <tab title="Returned">
            <ag-grid-angular class="data-grid " [rowData]="returnedFlows" [gridOptions]="returnedGridOptions"  [attr.aria-label]="widgetTitle + ' - Returned'"></ag-grid-angular>
        </tab>
        <tab title="Approved">
            <ag-grid-angular class="data-grid " [rowData]="approvedFlows" [gridOptions]="approvedGridOptions"  [attr.aria-label]="widgetTitle + ' - Approved'"></ag-grid-angular>
        </tab>
        <tab title="Denied">
            <ag-grid-angular class="data-grid " [rowData]="deniedFlows" [gridOptions]="deniedGridOptions"  [attr.aria-label]="widgetTitle + ' - Denied'"></ag-grid-angular>
        </tab>
        <tab title="Awaiting FA Return">
            <ag-grid-angular class="data-grid " [rowData]="faFlows" [gridOptions]="faGridOptions"  [attr.aria-label]="widgetTitle + ' - Awaiting FA Return'"></ag-grid-angular>
        </tab>
        <tab title="Complete">
            <ag-grid-angular class="data-grid " [rowData]="completeFlows" [gridOptions]="completeGridOptions"  [attr.aria-label]="widgetTitle + ' - Complete'"></ag-grid-angular>
        </tab>
    </tabs>
</div>